import { stateTypes, mutationTypes } from './landing.moduletypes';

const mutations = {};

export default mutations;
